export const STORAGE_KEYS = {
  QUESTIONS: 'questions',
  CURRENT_INDEX: 'currentQuestionIndex',
  LENGTH: 'questionLength',
  CURRENT_NUM: 'currentQuestionNum',
  WRONG_QUESTIONS: 'wrongQuestions'
}; 
